import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Widget from 'components/ui/layout/panel/Widget';

import {HTTP_STATUS_NOTFOUND} from 'util/api/Api';

import 'style/components/ui/layout/panel/message-panel.scss';

/** Component to render an error panel */
class MessagePanel extends Component {
    static propTypes = {
        title:   PropTypes.string, // The title to show
        code:    PropTypes.number, // Code of the message
        message: PropTypes.string // The message of the panel
    };

    renderImage() {
        const {code} = this.props;

        if (code === HTTP_STATUS_NOTFOUND) {
            return (
                <img src={require('img/not-found.png')} alt="404 error" height="185" width="115"/>
            );
        }

        return null;
    }

    render() {
        const {
            title,
            message
        } = this.props;

        return (
            <Widget className="message-panel">
                {this.renderImage()}
                <div className="alert">
                    <h2>{title}</h2>
                    <div className="alert-message">
                        <hr/>
                        <span>{message}</span>
                    </div>
                </div>
            </Widget>
        );
    }
}

export default MessagePanel;



// WEBPACK FOOTER //
// ./src/components/ui/layout/panel/MessagePanel.jsx